/**
 * Formateo de importes del POS.
 *
 * Reutiliza `window.currencyFormat`, que ya publica el layout
 * `backend/layouts/quick-booking.blade.php` con la moneda por defecto de la
 * instalacion (simbolo, decimales y separadores). Asi el POS muestra el dinero
 * igual que el resto de la aplicacion, sin duplicar la configuracion.
 *
 * OJO con el orden de carga: ese script del layout va DESPUES de
 * `modules/quickbooking/script.js`, asi que la funcion se resuelve en cada
 * llamada (no al importar el modulo) y se deja un fallback por si el layout
 * cambia. Un importe SIEMPRE se pinta; nunca un `undefined` en pantalla.
 */
export const money = (amount) => {
  const value = Number(amount) || 0

  if (typeof window !== 'undefined' && typeof window.currencyFormat === 'function') {
    try {
      return window.currencyFormat(value)
    } catch (e) {
      // Fallback silencioso: un fallo de formato no puede romper el cobro.
    }
  }

  const symbol = (typeof window !== 'undefined' && window.defaultCurrencySymbol) || ''

  return `${symbol}${value.toFixed(2)}`
}
